import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const VOICES = [
  {
    quote: "I kept meeting talented graduates who knew software but couldn't survive a real brief. LIMA exists so nobody has to learn the industry by failing in it.",
    name: "Amit Singh",
    role: "FOUNDER — LIFE INSIDE MEDIA",
  },
  {
    quote: "On our sets, a student doesn't watch — they slate, they light, they cut. By week two you're crew, not audience.",
    name: "Senior Mentor",
    role: "DIRECTION & PRODUCTION — LIM",
  },
  {
    quote: "Every edit you deliver here goes to a real client. That pressure is the teacher no tutorial can be.",
    name: "Senior Mentor",
    role: "POST-PRODUCTION — LIM",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-white/10" data-testid="testimonials-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-20">
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-lima-paper leading-[0.98]">
          Why we built
          <br />
          <span className="font-serifit font-normal text-lima-blue">this academy.</span>
        </h2>
        <p className="max-w-sm text-sm text-white/50 leading-relaxed">
          Words from the people who will train you — the working crew of Life Inside Media.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {VOICES.map((v, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="bg-lima-ink p-8 md:p-10 flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <Quote size={20} className="text-lima-blue mb-6" />
            <blockquote className="font-serifit text-xl md:text-2xl text-white/85 leading-snug flex-1">
              "{v.quote}"
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-white/10">
              <p className="font-display font-bold text-lima-paper">{v.name}</p>
              <p className="mt-1 font-mono2 text-[11px] tracking-[0.2em] text-white/40">{v.role}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
